module.exports = __webpack_public_path__ + "assets/img/1_539.ad9ced97.jpg";